import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtMXN } from "@/lib/format";
import { TrendingUp, ShoppingBag, Clock, DollarSign } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) {
    return <div className="p-10 text-white/50">Cargando...</div>;
  }

  const cards = [
    { label: "Hoy", icon: DollarSign, revenue: stats.today.revenue, orders: stats.today.orders, color: "arre-red" },
    { label: "Últimos 7 días", icon: TrendingUp, revenue: stats.week.revenue, orders: stats.week.orders, color: "white" },
    { label: "Últimos 30 días", icon: ShoppingBag, revenue: stats.month.revenue, orders: stats.month.orders, color: "white" },
    { label: "Pendientes de envío", icon: Clock, revenue: null, orders: stats.pending_fulfillment, color: "white", highlight: true },
  ];

  return (
    <div className="p-8 md:p-12" data-testid="admin-dashboard">
      <div className="text-xs tracking-[0.35em] uppercase text-arre-red mb-2">⟡ Admin</div>
      <h1 className="font-display text-5xl md:text-6xl tracking-wider uppercase text-white leading-none mb-10">
        Dashboard
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div
            key={c.label}
            className="bg-arre-surface border border-arre-border p-6"
            data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="text-[10px] tracking-[0.25em] uppercase text-white/50">{c.label}</div>
              <c.icon className={`w-5 h-5 ${c.color === "arre-red" ? "text-arre-red" : "text-white/40"}`} strokeWidth={1.5} />
            </div>
            {c.revenue !== null && (
              <div className="font-display text-4xl tracking-wider text-white">{fmtMXN(c.revenue)}</div>
            )}
            <div className={`mt-2 text-sm ${c.highlight ? "text-arre-red font-bold" : "text-white/60"}`}>
              {c.highlight ? `${c.orders} órdenes por preparar` : `${c.orders} ${c.orders === 1 ? "orden" : "órdenes"}`}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-arre-surface border border-arre-border p-6">
        <h2 className="font-display text-2xl tracking-wider uppercase text-white mb-2">Guía rápida</h2>
        <ul className="space-y-2 text-sm text-white/70">
          <li>• <span className="text-arre-red font-bold">Pedidos:</span> revisa y actualiza el estado de cada orden, envía WhatsApp automático al cliente.</li>
          <li>• <span className="text-arre-red font-bold">Productos:</span> gestiona stock, activa/desactiva cortes y marca destacados en home.</li>
          <li>• <span className="text-arre-red font-bold">Paquetes:</span> activa/desactiva los combos o marca cuáles aparecen destacados.</li>
          <li>• <span className="text-arre-red font-bold">Cupones:</span> crea códigos de descuento por % o $ fijo, con fechas y mínimos de compra.</li>
        </ul>
      </div>
    </div>
  );
}
